module.exports = __webpack_public_path__ + "static/media/WaterNSWlogo.3a1fd9a9.PNG";